export const questions = [
  {
    id: 1,
    question: "¿Cómo llevás actualmente la administración de tu negocio?",
    options: [
      {
        text: "Principalmente en papel o anotaciones.",
        score: 1,
      },
      {
        text: "Uso planillas de Excel/Google Sheets.",
        score: 2,
      },
      {
        text: "Tengo algún sistema, pero sigo haciendo muchas cosas manualmente.",
        score: 3,
      },
      {
        text: "Tengo un sistema integrado y la información está ordenada.",
        score: 4,
      },
    ],
  },

  {
    id: 2,
    question: "¿Sabés exactamente cuánto gana tu empresa?",
    options: [
      {
        text: "No con precisión.",
        score: 1,
      },
      {
        text: "Tengo una estimación.",
        score: 2,
      },
      {
        text: "Lo calculo periódicamente.",
        score: 3,
      },
      {
        text: "Tengo información actualizada sobre costos, ventas y rentabilidad.",
        score: 4,
      },
    ],
  },

  {
    id: 3,
    question: "¿Cuánto tiempo dedicás a tareas administrativas?",
    options: [
      {
        text: "Varias horas por día.",
        score: 1,
      },
      {
        text: "Algunas horas por semana.",
        score: 2,
      },
      {
        text: "Menos de lo que quisiera.",
        score: 3,
      },
      {
        text: "La mayoría de las tareas están organizadas o automatizadas.",
        score: 4,
      },
    ],
  },

  {
    id: 4,
    question: "¿Cómo controlás tus ventas?",
    options: [
      {
        text: "De memoria, WhatsApp o anotaciones.",
        score: 1,
      },
      {
        text: "En una planilla.",
        score: 2,
      },
      {
        text: "Con un sistema.",
        score: 3,
      },
      {
        text: "Tengo información y estadísticas de ventas en tiempo real.",
        score: 4,
      },
    ],
  },

  {
    id: 5,
    question: "¿Podés saber rápidamente cuánto vendiste este mes?",
    options: [
      {
        text: "Me cuesta mucho obtener ese dato.",
        score: 1,
      },
      {
        text: "Sí, pero tengo que revisar varias cosas.",
        score: 2,
      },
      {
        text: "Sí, tengo un registro bastante ordenado.",
        score: 3,
      },
      {
        text: "Sí, lo veo inmediatamente en un reporte o tablero.",
        score: 4,
      },
    ],
  },

  {
    id: 6,
    question: "¿Cómo gestionás tus clientes?",
    options: [
      {
        text: "Principalmente desde WhatsApp o contactos personales.",
        score: 1,
      },
      {
        text: "Tengo listas o planillas.",
        score: 2,
      },
      {
        text: "Utilizo algún sistema de clientes.",
        score: 3,
      },
      {
        text: "Tengo historial, seguimiento y segmentación de clientes.",
        score: 4,
      },
    ],
  },

  {
    id: 7,
    question: "¿Cuántas veces cargás la misma información?",
    options: [
      {
        text: "Muchas veces.",
        score: 1,
      },
      {
        text: "Bastantes veces.",
        score: 2,
      },
      {
        text: "Algunas veces.",
        score: 3,
      },
      {
        text: "Casi nunca.",
        score: 4,
      },
    ],
  },

  {
    id: 8,
    question: "¿Qué sucede cuando una persona clave de tu empresa no está?",
    options: [
        {
        text: "Trabajo Solo/a",
        score: 1,
      },
      {
        text: "Se frena gran parte del trabajo.",
        score: 1,
      },
      {
        text: "Tenemos dificultades para continuar.",
        score: 2,
      },
      {
        text: "Podemos continuar, aunque con algunas complicaciones.",
        score: 3,
      },
      {
        text: "Los procesos están documentados y organizados.",
        score: 4,
      },
    ],
  },

  {
    id: 9,
    question: "¿Tenés indicadores para saber cómo está funcionando tu negocio?",
    options: [
      {
        text: "No.",
        score: 1,
      },
      {
        text: "Miro principalmente cuánto vendo.",
        score: 2,
      },
      {
        text: "Controlo algunos indicadores.",
        score: 3,
      },
      {
        text: "Tengo indicadores y los utilizo para tomar decisiones.",
        score: 4,
      },
    ],
  },

  {
    id: 10,
    question:
      "Si quisieras implementar un nuevo sistema, ¿qué tan preparada está tu empresa?",
    options: [
      {
        text: "No sé por dónde empezar.",
        score: 1,
      },
      {
        text: "Tengo información, pero está desordenada.",
        score: 2,
      },
      {
        text: "Tenemos procesos bastante definidos.",
        score: 3,
      },
      {
        text: "Tenemos procesos claros y estamos preparados para digitalizarlos.",
        score: 4,
      },
    ],
  },

  {
    id: 11,
    question: "¿Qué problema te gustaría resolver primero?",
    options: [
      {
        text: "Ordenar la administración.",
        score: 1,
        category: "administracion",
      },
      {
        text: "Controlar mejor costos y dinero.",
        score: 1,
        category: "finanzas",
      },
      {
        text: "Aumentar ventas y mejorar la gestión de clientes.",
        score: 1,
        category: "ventas",
      },
      {
        text: "Automatizar tareas y ahorrar tiempo.",
        score: 1,
        category: "automatizacion",
      },
      {
        text: "Crear o mejorar un sistema de gestión.",
        score: 1,
        category: "sistemas",
      },
    ],
  },

  {
    id: 12,
    question: "¿Qué te impide hoy crecer más rápido?",
    options: [
      {
        text: "Falta de organización.",
        score: 1,
        category: "organizacion",
      },
      {
        text: "Falta de información para tomar decisiones.",
        score: 1,
        category: "informacion",
      },
      {
        text: "Demasiadas tareas manuales.",
        score: 1,
        category: "automatizacion",
      },
      {
        text: "Falta de tiempo.",
        score: 1,
        category: "tiempo",
      },
      {
        text: "Falta de herramientas tecnológicas.",
        score: 1,
        category: "tecnologia",
      },
      {
        text: "No tengo claro cuál es el principal problema.",
        score: 1,
        category: "diagnostico",
      },
    ],
  },
];